import { render, staticRenderFns } from "./CustomSelectionProjectsView.vue?vue&type=template&id=2c57b094&scoped=true&"
import script from "./CustomSelectionProjectsView.vue?vue&type=script&lang=js&"
export * from "./CustomSelectionProjectsView.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectionProjectsView.vue?vue&type=style&index=0&id=2c57b094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57b094",
  null
  
)

export default component.exports